import { render, staticRenderFns } from "./MachinationsLogoCustomColor.vue?vue&type=template&id=e8557348&"
import script from "./MachinationsLogoCustomColor.vue?vue&type=script&lang=ts&"
export * from "./MachinationsLogoCustomColor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports